var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.33 14.39C20.73 15.66 19.8 18 17.92 18H9.06C6.25 18 4 15.75 4 12.94V12.89C1.7 12.42 0 10.41 0 8C0 5.25 2.22 3 5 3H7.5C7.8 3 8 2.77 8 2.5C8 2.23 7.8 2 7.5 2H5V0H7.5C8.88 0 10 1.13 10 2.5C10 3.89 8.88 5 7.5 5H5C3.34 5 2 6.33 2 8C2 9.37 2.92 10.5 4.14 10.87C4.7 8.67 6.67 7 9.06 7C9.86 7 10.66 7.22 11.36 7.55C9.95 8.34 9 9.8 9 11.5C9 12.75 9.5 13.87 10.33 14.67L11.03 13.97C10.38 13.36 10 12.47 10 11.5C10 8.91 12.34 8 13.5 8C15.58 8 17.45 9.89 16.94 12.23L19.33 14.39ZM16 16C16.56 16 17 15.56 17 15C17 14.44 16.56 14 16 14C15.44 14 15 14.44 15 15C15 15.56 15.44 16 16 16Z",
    fill: "#595A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRat);
export default __webpack_public_path__ + "static/media/rat.f2a5f2fee060f2d655369f635105ef35.svg";
export { ForwardRef as ReactComponent };